module.exports = __webpack_public_path__ + "static/media/Resurshäfte SE full version.6f7d7666.pdf";